// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__39aqu","background":"styles_background__2ZOWm","content":"styles_content__3rdnN","more":"styles_more__11mi9","tip-holder":"styles_tip-holder__1SK8C"};